<template>
  <user-center-wrap>
    <div class="my-schedule">
      <div class="title">预约赛事</div>
      <div class="live-match" v-if="listData.length" v-loading="loading">
        <div v-for="(item, index) in listData" :key="index">
          <div class="match-nav">
            <div>{{ item.date }}</div>
            <!-- <div>{{ item.date.week2 }}</div> -->
          </div>
          <div>
            <MatchRecommendST :pendingMatch="item.match"></MatchRecommendST>
          </div>
        </div>
        <!--
        <div class="match-page">
          <el-pagination background
            layout="prev, pager, next"
            :page-size="pageNum"
            :total="totalCount"
            @current-change="handleCurrentChange"
            :current-page="page">
          </el-pagination>
        </div>
        -->
      </div>
      <Empty v-else text="暂时没有预约数据" :imgWidth="250"></Empty>
    </div>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../components/user-center-wrap/user-center-wrap";
import MatchRecommendST from "@/components/match-recommend/match-recommend-st";
import Empty from "@/components/empty/empty";
import { post } from "../../util/http";
import { h5Host } from "../../util/host";
import getPlatform from "../../util/platform";
import { dayCount } from "@/util/time";

export default {
  async asyncData({ req, redirect }) {
    if (req && process.server && getPlatform(req) === "h5") {
      redirect(h5Host + "/user-center/mySchedule");
    }
  },
  // middleware: "login-check",
  components: {
    UserCenterWrap,
    MatchRecommendST,
    Empty,
  },
  data() {
    return {
      loading: true,
      pageNum: 20,
      totalCount: 0,
      page: 1,
      sport_type: "",
      in_live: 0,
      searchData: {
        competition_id: 0,
        date: "",
        page: 1,
        sport_type: "",
        in_live: 0,
      },
      listData: [],
    };
  },
  created() {
    this.search();
  },
  mounted() {},
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },

    search() {
      this.searchData = {
        page: this.page || 1,
        sport_type: this.sport_type || "",
        in_live: this.in_live || 0,
      };
      this.getUserReservation();
    },

    getUserReservation() {
      this.loading = true;
      post({
        url: "/api/match/getReservedMatch4Crawler",
        data: {
          ...this.searchData,
        },
      }).then(({ data: { data } }) => {
        //let {match=[],total=0 } = data;
        //this.pendingMatch = match || []
        // data = data || [];
        // let dateObj = {},
        //   listData = [];
        // data.forEach((v) => {
        //   v.is_reservation = 1;
        //   if (dateObj.hasOwnProperty(v.match_date) && dateObj[v.match_date]) {
        //     dateObj[v.match_date].push(v);
        //   } else {
        //     dateObj[v.match_date] = [];
        //     dateObj[v.match_date].push(v);
        //   }
        // });
        // for (let i in dateObj) {
        //   if (dateObj.hasOwnProperty(i) && dateObj[i]) {
        //     listData.push({
        //       date: dayCount(0, i),
        //       data: dateObj[i],
        //     });
        //   }
        // }
        // console.log("listData: ", listData);
        this.listData = data || [];
        this.loading = false;
        //this.pendingMatch = data;
        // console.log("this.pendingMatch: ",this.pendingMatch);
        //
        // this.totalCount = total;
      });
    },
  },
};
</script>

<style lang="scss">
.my-schedule {
  // width: 992px;
  background-color: #fff;
  padding-top: 16px;
  padding-left: 40px;
  padding-right: 40px;
  flex: 1;
  .title {
    font-size: 18px;
    color: #333;
    font-weight: 700;
    position: relative;
    width: 72px;
    text-align: center;
    z-index: 2;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: -3px;
      width: 100%;
      height: 6px;
      background: #26d99d;
      border-radius: 35px;
      z-index: -1;
    }
  }

  .live-match {
    min-height: 600px;
    padding-top: 30px;
    .match-nav {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 20px 0px;
      font-size: 20px;
      color: #333333;
      div {
        margin-right: 10px;
      }
    }
  }
  .match-page {
    display: flex;
    justify-content: center;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #26d99d;
  }
  .el-loading-spinner .path {
    stroke: #26d99d;
  }
}
</style>
